<div class="master-modal terms_modal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Terms & Conditions for Professionals</h4>
        <!-- Optional close button -->
        
        <!-- <div class="modal_close_btn">
          <span (click)="dialogClose('no')" class="modal-close">
            <i class="material-icons">close</i>
          </span>
        </div>  -->
       
      </div>

      <!-- Modal Body -->
      <div mat-dialog-content>
        <div class="modal-body">
          <p>
            Welcome to our Professional Directory. By creating your account and using our platform, 
            you agree to the following Terms and Conditions:
          </p>

          <ol class="terms-list">
            <li>
              <strong>Account Responsibility:</strong> You are responsible for maintaining the confidentiality 
              of your account credentials and ensuring that the information you provide is accurate and up to date.
            </li>
            <li>
              <strong>Professional Conduct:</strong> All listings and interactions must reflect professional behavior. 
              Any misleading, false, or inappropriate content may result in account suspension.
            </li>
            <li>
              <strong>Use of Information:</strong> The information you provide (such as name, qualification, 
              contact details) will be displayed publicly in your directory profile as per your consent.
            </li>
            <li>
              <strong>Compliance:</strong> You must comply with applicable laws, professional guidelines, 
              and community standards while using this platform.
            </li>
            <li>
              <strong>Platform Rights:</strong> We reserve the right to review, modify, or remove 
              any content that violates these terms or affects platform integrity.
            </li>
            <li>
              <strong>Termination:</strong> Violation of these terms may lead to temporary or permanent suspension of your account.
            </li>
          </ol>

          <p>
            By clicking <strong>“I Agree”</strong>, you confirm that you have read and accepted these Terms and Conditions.
          </p>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <div mat-dialog-actions class="modal_footer">
          <button mat-button (click)="onConfirm()" class="modal-save-btn global-btn modal-footer-btn">
            <span>I Agree</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
